import { FC } from "react";

import { useTheme } from "@mui/material/styles";
import { useDrawingArea, useXScale, useYScale } from "@mui/x-charts/hooks";

export const ChartBarZeroLine: FC = () => {
  const theme = useTheme();
  const { left } = useDrawingArea();
  const xScale = useXScale<"band">();
  const yScale = useYScale<"linear">();

  const categories = xScale.domain();
  const lastCategory = categories[categories.length - 1];
  const zeroY = yScale(0);
  const lastBarStart = lastCategory === undefined ? undefined : xScale(lastCategory);
  if (lastBarStart === undefined || zeroY === undefined) {
    return null;
  }

  return (
    <line
      x1={left}
      x2={lastBarStart + xScale.bandwidth()}
      y1={zeroY}
      y2={zeroY}
      stroke={theme.palette.border.neutral.intense}
      strokeWidth={2}
      strokeLinecap="round"
    />
  );
};
